import Leaflet from 'leaflet';
import Draw from 'leaflet-draw';

//import MarkerCluster from  'leaflet.markercluster';
const mc = require('leaflet.markercluster');
//const leafletDraw = require('leaflet-draw');

// eslint-disable-next-line import/no-anonymous-default-export
export default { ...Leaflet, ...mc, Draw };
